import React from 'react'
import ReactDOM from 'react-dom'

import { getInstance, registerRemotes, registerShared } from '@module-federation/enhanced/runtime'

import { Logger } from './logger'

import { DEVELOPMENT_REMOTES, PRODUCTION_REMOTES } from './remotes'

import packageJson from '../../../package.json'

Logger.setOptions({ enabled: process.env.TARGET_ENV !== 'production' })

import './plugins'

function getRemotes() {
  if (process.env.TARGET_ENV === 'production') {
    return PRODUCTION_REMOTES
  }

  return DEVELOPMENT_REMOTES
}

getInstance()

registerRemotes(getRemotes())

registerShared({
  react: {
    version: packageJson.dependencies.react,
    scope: 'default',
    lib: () => React,
    shareConfig: {
      singleton: true,
      requiredVersion: packageJson.dependencies.react
    }
  },
  'react-dom': {
    version: packageJson.dependencies['react-dom'],
    scope: 'default',
    lib: () => ReactDOM,
    shareConfig: {
      singleton: true,
      requiredVersion: packageJson.dependencies['react-dom']
    }
  }
})
